import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Header from "@/components/app/Header";
import { useSeo } from "@/lib/seo";

export default function Login() {
  useSeo({
    title: "Sign in",
    description: "Sign in to Chapter and continue building shared video tributes for weddings, birthdays, farewells and the moments that matter.",
    path: "/login",
  });
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) { toast.success("Welcome back"); navigate("/dashboard"); }
    else toast.error(r.error);
  };

  return (
    <div className="min-h-screen bg-[var(--em-bg)]">
      <Header />
      <div className="max-w-md mx-auto px-6 pt-16 pb-24">
        <p className="font-mono-label text-[var(--em-clay)]">Sign in</p>
        <h1 className="font-serif-em text-4xl mt-3">Welcome back.</h1>
        <p className="mt-2 text-[var(--em-ink-soft)]">Continue building memories that last.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label htmlFor="email" className="font-mono-label">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11 bg-white" />
          </div>
          <div>
            <Label htmlFor="password" className="font-mono-label">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11 bg-white" />
          </div>
          <Button data-testid="login-submit-btn" disabled={busy} className="w-full h-11 rounded-full bg-[var(--em-clay)] hover:bg-[var(--em-clay-deep)] text-white btn-lift">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-[var(--em-ink-soft)]">
          No account yet?{" "}
          <Link to="/signup" data-testid="login-go-signup" className="text-[var(--em-clay)] underline underline-offset-4">Create one</Link>
        </p>
      </div>
    </div>
  );
}
